import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-text',
  templateUrl: './terms-text.component.html',
  styleUrls: ['./terms-text.component.scss']
})
export class TermsTextComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
